<template>
  <Modal>
    <div
      slot="header"
      class="question"
    >
      <h2>{{ question }}</h2>
    </div>
    <div class="answer">
      {{ answer }}
    </div>
  </Modal>
</template>
<script>
import Modal from "@/components/ComponentModal";

export default {
  components: {
    Modal
  },
  props: {
    question: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false
    };
  }
};
</script>
<style scoped>
h2 {
  font-size: 28px;
  font-weight: bold;
  padding-bottom: 14px;
  border-bottom: 1px solid #e7e7e7;
}
</style>
